const state = {
    stops: [],
    stops_created_at: Date.now(),
    destinations: [],
    destinations_created_at: Date.now(),
    product_list: [],
    product_list_created_at: Date.now(),
    calendar_dates: [],
    calendar_dates_created_at: Date.now(),
    trips: [],
    trips_created_at: Date.now(),
    search_paras: {},
    selected_products: '',
}

// getters
const getters = {
    stops: (state) => {
        return ((Date.now() - state.stops_created_at) < 1000 * 60 * 20) ? state.stops : [];
    },
    destinations: (state) => {
        return ((Date.now() - state.destinations_created_at) < 1000 * 60 * 20) ? state.destinations : [];
    },
    product_list: (state) => {
        return ((Date.now() - state.product_list_created_at) < 1000 * 60 * 20) ? state.product_list : [];
    },
    calendar_dates: (state) => {
        return ((Date.now() - state.calendar_dates_created_at) < 1000 * 60 * 20) ? state.calendar_dates : [];
    },
    search_paras: (state) => {
        return state.search_paras;
    },
    selected_products: (state) => {
        return state.selected_products;
    },
}
// mutations
const mutations = {
    set_stops(state, stops) {
        state.stops = stops;
        state.stops_created_at = Date.now();
    },
    set_destinations(state, destinations) {
        state.destinations = destinations;
        state.destinations_created_at = Date.now();
    },
    set_product_list(state, product_list) {
        state.product_list = product_list;
        state.product_list_created_at = Date.now();
    },
    set_calendar_dates(state, calendar_dates) {
        state.calendar_dates = calendar_dates;
        state.calendar_dates_created_at = Date.now();
    },
    set_trips(state, { trips }) {
        state.trips = trips;
    },
    set_search_paras(state, search_paras) {
        state.search_paras = search_paras;
    },
    set_selected_products(state, selected_products) {
        state.selected_products = selected_products;
    }
}
// actions
const actions = {

}



export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
